
import { Phone } from 'lucide-react';
import ContactMethod from './ContactMethod';
import EmailContact from './EmailContact';
import ContactCTA from './ContactCTA';
import { useEffect } from 'react';

const ContactSection = () => {
  const contactMethods = [
    {
      type: 'General Phone Support',
      value: '(240) 219-8426',
      icon: Phone,
      href: 'tel:+12402198426',
      primary: true
    },
    {
      type: 'Account Management',
      value: '(240) 253-9227',
      icon: Phone,
      href: 'tel:+12402539227',
      primary: true,
      subtitle: 'For Business Clients'
    },
    {
      type: 'WhatsApp Support',
      value: '(269) 883-1576',
      icon: Phone,
      href: 'https://wa.me/12698831576',
      primary: true
    }
  ];

  const emailContacts = [
    {
      type: 'Sales Support',
      value: 'sales@nexx.net',
      href: 'mailto:sales@nexx.net'
    },
    {
      type: 'Technical Support',
      value: 'support@nexx.net',
      href: 'mailto:support@nexx.net'
    },
    {
      type: 'Report Abuse',
      value: 'abuse@nexx.net',
      href: 'mailto:abuse@nexx.net'
    },
    {
      type: 'Peering Contact',
      value: 'peering@nexx.net',
      href: 'mailto:peering@nexx.net'
    }
  ];

  // Safe CSS injection using CSS custom properties
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .glitch-text {
        position: relative;
        font-weight: bold;
        animation: glitch 2s infinite;
      }
      
      .glitch-text::before,
      .glitch-text::after {
        content: 'fast';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      
      .glitch-text::before {
        animation: glitch-1 2s infinite;
        color: #ff0000;
        z-index: -1;
      }
      
      .glitch-text::after {
        animation: glitch-2 2s infinite;
        color: #00ff00;
        z-index: -2;
      }
      
      @keyframes glitch {
        0%, 100% { transform: translate(0); }
        20% { transform: translate(-1px, 1px); }
        40% { transform: translate(-1px, -1px); }
        60% { transform: translate(1px, 1px); }
        80% { transform: translate(1px, -1px); }
      }
      
      @keyframes glitch-1 {
        0%, 100% { transform: translate(0); }
        20% { transform: translate(1px, -1px); }
        40% { transform: translate(-1px, 1px); }
        60% { transform: translate(-1px, -1px); }
        80% { transform: translate(1px, 1px); }
      }
      
      @keyframes glitch-2 {
        0%, 100% { transform: translate(0); }
        20% { transform: translate(-1px, -1px); }
        40% { transform: translate(1px, 1px); }
        60% { transform: translate(1px, -1px); }
        80% { transform: translate(-1px, 1px); }
      }
    `;
    
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <section className="py-12 bg-gray-50 relative overflow-hidden section-float">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Talk to <span className="text-nexx-green drop-shadow-[0_0_10px_rgba(34,197,94,0.5)]">People</span> Who Get It
          </h2>
          <p className="text-lg text-gray-600">
            Got questions? We speak infra—and we move{' '}
            <span className="relative inline-block animate-pulse">
              <span className="glitch-text">fast</span>
            </span>.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-start">
          {/* Primary Contact Methods */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Talk to Us</h3>
            
            {contactMethods.map((contact, index) => (
              <ContactMethod
                key={index}
                type={contact.type}
                value={contact.value}
                icon={contact.icon}
                href={contact.href}
                subtitle={contact.subtitle}
              />
            ))}
          </div>

          {/* Email Contacts */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Email Support</h3>
            
            <div className="space-y-2">
              {emailContacts.map((email, index) => (
                <EmailContact
                  key={index}
                  type={email.type}
                  value={email.value}
                  href={email.href}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <ContactCTA />
      </div>
    </section>
  );
};

export default ContactSection;
